import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { Form, Input } from 'ui/base';

const compareToFirstPassword = (value, values) => values.password !== value;

const PasswordConfirm = ({ label }) => {
  const intl = useIntl();

  return (
    <Field name="passwordConfirm" validate={compareToFirstPassword} validateFields={[]}>
      {props => (
        <Form.Item
          required
          label={label}
          className="ant-form-vertical"
          validateStatus={props.meta.error && 'error'}
          help={
            props.meta.error && (
              <FormattedMessage
                id="page.user.error.confirmation_password.not_identical"
                defaultMessage="The password confirmation is not identical to the password."
              />
            )
          }
        >
          <Input.Password
            {...props.input}
            placeholder={intl.formatMessage({ id: 'confirmPassword', defaultMessage: 'Password confirmation' })}
            autoComplete="new-password"
            data-cy="input-passwordConfirm"
          />
        </Form.Item>
      )}
    </Field>
  );
};

export default PasswordConfirm;
